import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import { isRoot } from "utils/treeUtils";

export const getPath = (n: NodeApi, list: string[] = []): string => {
  if (isRoot(n.data)) {
    return list.reverse().join("\\");
  }
  if (!n.parent) {
    throw new Error("Node does not have a parent");
  }
  return getPath(n.parent, [...list, n.data.folderName]);
};
